import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function ClubPayResult() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [st, setSt] = useState({ payment_status: "pending" });
  const tries = useRef(0);

  useEffect(() => {
    if (!sid) return undefined;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/club/payments/status/${sid}`);
        setSt(data);
        if (data.payment_status !== "pending") return;
      } catch { setSt((s) => ({ ...s, error: true })); }
      if (++tries.current > 15) { setSt((s) => ({ ...s, timeout: true })); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sid]);

  const paid = st.payment_status === "paid";
  const failed = !paid && (st.timeout || ["failed", "expired"].includes(st.payment_status) || !sid);
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="club-pay-result">
      <h1 className="font-display font-black uppercase text-4xl text-[#0B1D3A]">{paid ? "¡Inscripción pagada!" : failed ? "No hemos podido confirmar el pago" : "Comprobando el pago…"}</h1>
      <p className="mt-3 text-slate-600" data-testid="club-pay-status">{paid ? "Tu inscripción está confirmada. Te avisaremos cuando se publique el orden de salida." : failed ? "Si se te ha cobrado, la inscripción se confirmará sola en unos minutos. Si no, vuelve al concurso e inténtalo de nuevo." : "Esto tarda unos segundos. No cierres esta página."}</p>
      {st.competition_id ? <Link to={`/club/concurso/${st.competition_id}`} className="inline-block mt-6 bg-[#B23A38] text-white font-bold px-6 py-3 rounded-full" data-testid="club-pay-back">Volver al concurso</Link>
        : failed && <Link to="/club" className="inline-block mt-6 bg-[#B23A38] text-white font-bold px-6 py-3 rounded-full" data-testid="club-pay-hub">Ir a FAUNNY Club</Link>}
    </div>
  );
}
